import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';

function SuccessPage({ onLogin }) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const sessionId = searchParams.get('session_id');
    if (!sessionId) {
      navigate('/');
      return;
    }

    axios
      .get(`${process.env.REACT_APP_VISION_AI_STREAM_API_URL}/api/users/confirm-session?session_id=${sessionId}`)
      .then((res) => {
        const { user } = res.data;

        // 1) Pega do sessionStorage o user anterior (com a password pura, se houver)
        const storedUserString = sessionStorage.getItem('user') || '{}';
        let storedPassword = '';
        try {
          const storedUser = JSON.parse(storedUserString);
          storedPassword = storedUser.password || '';
        } catch (err) {
          console.error('[SuccessPage] Erro ao ler storedUser:', err);
        }

        // 2) Mescla user do backend com a password pura
        const mergedUser = {
          ...user,
          password: storedPassword,
        };

        // 3) Salva mergedUser no sessionStorage
        sessionStorage.setItem('user', JSON.stringify(mergedUser));

        // 4) Verifica status do plano
        const planStatus = mergedUser.planDetails?.status;

        if (planStatus === 'active') {
          // Marca login como "active"
          onLogin('active');

          // Pega o idioma (default 'en' se não vier)
          const selectedLanguage = mergedUser.language || 'en';

          // Redireciona p/ video-editor, passando state e user mesclado
          navigate('/video-editor', {
            state: {
              selectedLanguage,
              user: mergedUser,
            },
          });
        } else if (planStatus === 'pending') {
          // Se ainda está pendente
          onLogin('pending');
          navigate('/plan-selection');
        } else {
          // Status inesperado => redireciona pro login
          console.warn('[SuccessPage] Status inesperado:', planStatus);
          navigate('/');
        }
      })
      .catch((err) => {
        console.error('Erro ao confirmar sessão:', err);
        navigate('/');
      });
  }, [searchParams, navigate, onLogin]);

  return (
    <div style={{ textAlign: 'center', marginTop: '30px' }}>
      <h2>Processando pagamento...</h2>
      <p>Aguarde enquanto finalizamos seu plano.</p>
    </div>
  );
}

export default SuccessPage;
